<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { action } from "@/components/action/action";
import { boardKey } from "@/components/board/injectKeys";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import { isActionVisible } from "@/components/utils/actions";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const visible = computed(() => isActionVisible("link", card, board.value));
</script>

<template>
  <IconButton v-if="visible" v-bind="action(cardActions.openLinkModal)" />
</template>
